// extracted by mini-css-extract-plugin
module.exports = {"container":"e_zr","title":"e_Ar","titleIcon":"e_Br","summary":"e_Cr","sourcesTitle":"e_Dr","sources":"e_Er","source":"e_Fr"};